import TeamTableRow from '@/utils/classes/TeamTableRow';
import { getDataTablesCategories } from '@/utils/misc';

// Data structure for the possession table data rows
export const possessionTeamTableRowItems = [
  {
    category: 'PASES ACERTADOS',
    categoryIds: null,
    translationKey: 'table.possession.team.successful_passes',
    singleName: 'Pase acertado',
    generalName: 'Pases acertados',
    items: [
      {
        category: 'PASES ACERTADOS EN 1/4',
        categoryIds: [213],
        translationKey: 'table.possession.team.successful_passes_1/4',
        singleName: 'Pase acertado en 1/4',
        generalName: 'Pases acertados en 1/4',
      },
      {
        category: 'PASES ACERTADOS EN 2/4',
        categoryIds: [214],
        translationKey: 'table.possession.team.successful_passes_2/4',
        singleName: 'Pase acertado en 2/4',
        generalName: 'Pases acertados en 2/4',
      },
      {
        category: 'PASES ACERTADOS EN 3/4',
        categoryIds: [215],
        translationKey: 'table.possession.team.successful_passes_3/4',
        singleName: 'Pase acertado en 3/4',
        generalName: 'Pases acertados en 3/4',
      },
      {
        category: 'PASES ACERTADOS EN 4/4',
        categoryIds: [216],
        translationKey: 'table.possession.team.successful_passes_4/4',
        singleName: 'Pase acertado en 4/4',
        generalName: 'Pases acertados en 4/4',
      },
    ],
  },
  {
    category: 'PASES FILTRADOS',
    categoryIds: [217],
    translationKey: 'table.possession.team.through_passes',
    singleName: 'Pase filtrado',
    generalName: 'Pases filtrados',
  },
  {
    category: 'PASES NO ACERTADOS',
    categoryIds: null,
    translationKey: 'table.possession.team.unsuccessful_passes',
    generalName: 'Pases no acertados',
    singleName: 'Pase no acertado',
    items: [
      {
        category: 'PASES NO ACERTADOS EN 1/4',
        categoryIds: [218],
        translationKey: 'table.possession.team.unsuccessful_passes_1/4',
        generalName: 'Pases no acertados en 1/4',
        singleName: 'Pase no acertado en 1/4',
      },
      {
        category: 'PASES NO ACERTADOS EN 2/4',
        categoryIds: [219],
        translationKey: 'table.possession.team.unsuccessful_passes_2/4',
        generalName: 'Pases no acertados en 2/4',
        singleName: 'Pase no acertado en 2/4',
      },
      {
        category: 'PASES NO ACERTADOS EN 3/4',
        categoryIds: [220],
        translationKey: 'table.possession.team.unsuccessful_passes_3/4',
        generalName: 'Pases no acertados en 3/4',
        singleName: 'Pase no acertado en 3/4',
      },
      {
        category: 'PASES NO ACERTADOS EN 4/4',
        categoryIds: [221],
        translationKey: 'table.possession.team.unsuccessful_passes_4/4',
        generalName: 'Pases no acertados en 4/4',
        singleName: 'Pase no acertado en 4/4',
      },
    ],
  },
  {
    category: 'BALONES RECUPERADOS EN DISPUTA',
    categoryIds: null,
    translationKey: 'table.possession.team.ball_recovered_in_challenge',
    generalName: 'Balones recuperados en disputa',
    singleName: 'Balón recuperado en disputa',
    items: [
      {
        category: 'B.R.E.D CANCHA PROPIA',
        categoryIds: [485, 486],
        translationKey: 'table.possession.team.b_r_i_c_own_half',
        generalName: 'B.R.E.D cancha propia',
        singleName: 'B.R.E.D cancha propia',
      },
      {
        category: 'B.R.E.D CANCHA RIVAL',
        categoryIds: [487, 488],
        translationKey: 'table.possession.team.b_r_i_c_opponents_half',
        generalName: 'B.R.E.D cancha rival',
        singleName: 'B.R.E.D cancha rival',
      },
    ],
  },
  {
    category: 'BALONES RECUPERADOS SIN DISPUTA',
    categoryIds: null,
    translationKey: 'table.possession.team.ball_recovered_without_challenge',
    generalName: 'Balones recuperados sin disputa',
    singleName: 'Balon recuperado sin disputa',
    items: [
      {
        category: 'B.R.S.D CANCHA PROPIA',
        categoryIds: [489, 490],
        translationKey: 'table.possession.team.b_r_w_c_own_half',
        generalName: 'B.R.S.D cancha propia',
        singleName: 'B.R.S.D cancha propia',
      },
      {
        category: 'B.R.S.D CANCHA RIVAL',
        categoryIds: [491, 492],
        translationKey: 'table.possession.team.b_r_w_c_opponents_half',
        generalName: 'B.R.S.D cancha rival',
        singleName: 'B.R.S.D cancha rival',
      },
    ],
  },
  {
    category: 'BALONES PERDIDOS EN DISPUTA',
    categoryIds: null,
    translationKey: 'table.possession.team.balls_lost_in_challenge',
    generalName: 'Balones perdidos en disputa',
    singleName: 'Balon perdido en disputa',
    items: [
      {
        category: 'B.P.E.D. CANCHA PROPIA',
        categoryIds: [496, 497],
        translationKey: 'table.possession.team.b_l_i_c_own_half',
        generalName: 'B.P.E.D. cancha propia',
        singleName: 'B.P.E.D. cancha propia',
      },
      {
        category: 'B.P.E.D. CANCHA RIVAL',
        categoryIds: [498, 499],
        translationKey: 'table.possession.team.b_l_i_c_opponents_half',
        generalName: 'B.P.E.D. cancha rival',
        singleName: 'B.P.E.D. cancha rival',
      },
    ],
  },
  {
    category: 'BALONES PERDIDOS SIN DISPUTA',
    categoryIds: null,
    translationKey: 'table.possession.team.balls_lost_without_challenge',
    generalName: 'Balones perdidos sin disputa',
    singleName: 'Balon perdido sin disputa',
    items: [
      {
        category: 'B.P.S.D. CANCHA PROPIA',
        categoryIds: [500, 501],
        translationKey: 'table.possession.team.b_l_w_c_own_half',
        generalName: 'B.P.S.D. cancha propia',
        singleName: 'B.P.S.D. cancha propia',
      },
      {
        category: 'B.P.S.D. CANCHA RIVAL',
        categoryIds: [502, 503],
        translationKey: 'table.possession.team.b_l_w_c_opponents_half',
        generalName: 'B.P.S.D. cancha rival',
        singleName: 'B.P.S.D. cancha rival',
      },
    ],
  },
];

// Data structure for the offensive table data rows
export const offensiveTeamTableRowItems = [
  {
    category: 'GOLES',
    categoryIds: null,
    translationKey: 'table.offensive.team.goals',
    generalName: 'Goles',
    singleName: 'Gol',
    items: [
      {
        category: 'GOLES PIE DENTRO DEL ÁREA',
        categoryIds: [57],
        translationKey: 'table.offensive.team.goals_foot_inside_penalty',
        generalName: 'Goles pie dentro del área',
        singleName: 'Gol pie dentro del área',
      },
      {
        category: 'GOLES PIE FUERA DEL ÁREA',
        categoryIds: [326],
        translationKey: 'table.offensive.team.goals_foot_outside_penalty',
        generalName: 'Goles pie fuera del área',
        singleName: 'Gol pie fuera del área',
      },
      {
        category: 'GOLES CABEZA',
        categoryIds: [56],
        translationKey: 'table.offensive.team.header_goals',
        generalName: 'Goles cabeza',
        singleName: 'Gol cabeza',
      },
      {
        category: 'GOLES TIRO LIBRE',
        categoryIds: [60],
        translationKey: 'table.offensive.team.free_kick_goals',
        generalName: 'Goles tiro libre',
        singleName: 'Gol tiro libre',
      },
      {
        category: 'GOLES PENAL',
        categoryIds: [59],
        translationKey: 'table.offensive.team.penalty_goals',
        generalName: 'Goles penal',
        singleName: 'Gol penal',
      },
      {
        category: 'GOLES DE PORTERO',
        categoryIds: [55],
        translationKey: 'table.offensive.team.goalkeeper_goals',
        generalName: 'Goles de portero',
        singleName: 'Gol de portero',
      },
      {
        category: 'AUTOGOLES',
        rCategoryIds: [35, 54],
        translationKey: 'table.offensive.team.opponents_own_goals',
        generalName: 'Autogoles a favor',
        singleName: 'Autogol',
      },
    ],
  },
  {
    category: 'TIROS A GOL (ORIGEN)',
    categoryIds: null,
    translationKey: 'table.offensive.team.shots_on_goal_from',
    generalName: 'Tiros a gol (origen)',
    singleName: 'Tiro a gol (origen)',
    items: [
      {
        category: 'DENTRO DEL ÁREA',
        categoryIds: [514, 516],
        translationKey: 'table.offensive.team.inside_the_box',
        generalName: 'Tiros a gol dentro del área',
        singleName: 'Tiro a gol dentro del área',
      },
      {
        category: 'FUERA DEL ÁREA',
        categoryIds: [513, 515],
        translationKey: 'table.offensive.team.outside_the_box',
        generalName: 'Tiros a gol fuera del área',
        singleName: 'Tiro a gol fuera del área',
      },
    ],
  },
  {
    category: 'TIROS A GOL (DESTINO)',
    categoryIds: null,
    translationKey: 'table.offensive.team.shots_on_goal_to',
    generalName: 'Tiros a gol (destino)',
    singleName: 'Tiro a gol (destino)',
    items: [
      {
        category: 'CON DESTINO A PORTERÍA',
        generalName: 'Tiros a gol con destino a portería',
        categoryIds: [537, 540, 544, 547],
        translationKey: 'table.offensive.team.shots_on_goal',
      },
      {
        category: 'SIN DESTINO A PORTERÍA',
        generalName: 'Tiros a gol sin destino a portería',
        categoryIds: [538, 541, 545, 548],
        translationKey: 'table.offensive.team.not_to_destiny',
      },
      {
        category: 'BLOQUEADOS',
        generalName: 'Tiros a gol bloqueados',
        categoryIds: [539, 542, 546, 549],
        items: null,
        categoriesTypes: [2, 3],
        translationKey: 'table.offensive.team.blocked',
      },
    ],
  },
  {
    category: 'CENTROS POR IZQUIERDA',
    singleName: 'Centro por izquierda',
    categoryIds: null,
    translationKey: 'table.offensive.team.centers_from_left',
    items: [
      {
        category: 'C.P.I. ACERTADOS',
        singleName: 'C.P.I. acertado',
        categoryIds: [98, 101, 104, 105],
        translationKey: 'table.offensive.team.successful_c_f_l_s',
      },
      {
        category: 'C.P.I. NO ACERTADOS',
        categoryIds: [106, 107, 108],
        translationKey: 'table.offensive.team.unsuccessful_c_f_l_s',
      },
    ],
  },
  {
    category: 'CENTROS POR DERECHA',
    categoryIds: null,
    translationKey: 'table.offensive.team.centers_from_right',
    items: [
      {
        category: 'C.P.D. ACERTADOS',
        categoryIds: [109, 112, 115, 116],
        translationKey: 'table.offensive.team.successful_c_f_r_s',
      },
      {
        category: 'C.P.D. NO ACERTADOS',
        categoryIds: [117, 118, 119],
        translationKey: 'table.offensive.team.unsuccessful_c_f_r_s',
      },
    ],
  },
  {
    category: 'BALONES GANADOS EN ÁREA RIVAL',
    categoryIds: [11],
    translationKey: 'table.offensive.team.balls_won_opponents_penalty',
  },
];

// Data structure for the defensive table data rows
export const defensiveTeamTableRowItems = [
  {
    category: 'GOLES RECIBIDOS',
    categoryIds: null,
    translationKey: 'table.defensive.team.goals_received',
    items: [
      {
        category: 'GOLES PIE DENTRO DEL ÁREA',
        rCategoryIds: [57],
        translationKey: 'table.defensive.team.goals_foot_inside_penalty',
      },
      {
        category: 'GOLES PIE FUERA DEL ÁREA',
        rCategoryIds: [326],
        translationKey: 'table.defensive.team.goals_foot_outside_penalty',
      },
      {
        category: 'GOLES DE CABEZA',
        rCategoryIds: [56],
        translationKey: 'table.defensive.team.header_goals',
      },
      {
        category: 'GOLES DE TIRO LIBRE',
        rCategoryIds: [60],
        translationKey: 'table.defensive.team.free_kick_goals',
      },
      {
        category: 'GOLES DE PENAL',
        rCategoryIds: [59],
        translationKey: 'table.defensive.team.penalty_goals',
      },
      {
        category: 'GOLES DE PORTERO RECIBIDOS',
        rCategoryIds: [55],
        translationKey: 'table.defensive.team.goalkeeper_goals',
      },
      {
        category: 'AUTOGOLES',
        categoryIds: [35, 54],
        translationKey: 'table.defensive.team.opponents_own_goals',
      },
    ],
  },
  {
    category: 'TIROS A GOL RECIBIDOS (ORIGEN)',
    categoryIds: null,
    translationKey: 'table.defensive.team.shots_on_goal_from',
    items: [
      {
        category: 'DENTRO DEL ÁREA',
        generalName: 'Tiros a gol recibidos dentro del área',
        rCategoryIds: [514, 516],
        translationKey: 'table.defensive.team.inside_the_box',
      },
      {
        category: 'FUERA DEL ÁREA',
        generalName: 'Tiros a gol recibidos fuera del área',
        rCategoryIds: [513, 515],
        translationKey: 'table.defensive.team.outside_the_box',
      },
    ],
  },
  {
    category: 'TIROS A GOL RECIBIDOS (DESTINO)',
    categoryIds: null,
    translationKey: 'table.defensive.team.shots_on_goal_to',
    items: [
      {
        category: 'CON DESTINO A PORTERÍA',
        rCategoryIds: [537, 540, 544, 547],
        translationKey: 'table.defensive.team.shot_on_goal',
        generalName: 'Tiros a gol recibidos con destino a portería',
      },
      {
        category: 'SIN DESTINO A PORTERÍA',
        rCategoryIds: [538, 541, 545, 548],
        translationKey: 'table.defensive.team.missed',
        generalName: 'Tiros a gol recibidos sin destino a portería',
      },
      {
        category: 'BLOQUEADOS',
        categoryIds: null,
        rCategoryIds: [539, 542, 546, 549],
        translationKey: 'table.defensive.team.blocked',
        generalName: 'Tiros a gol recibidos bloqueados',
      },
    ],
  },
  {
    category: 'CENTROS POR IZQUIERDA RECIBIDOS',
    categoryIds: null,
    translationKey: 'table.defensive.team.centers_left_side_received',
    items: [
      {
        category: 'C.P.I.R. ACERTADOS',
        rCategoryIds: [109, 112, 115, 116],
        translationKey: 'table.defensive.team.successful_c_f_l_r',
      },
      {
        category: 'C.P.I.R. NO ACERTADOS',
        rCategoryIds: [117, 118, 119],
        translationKey: 'table.defensive.team.unsuccessful_c_f_l_r',
      },
    ],
  },
  {
    category: 'CENTROS POR DERECHA RECIBIDOS',
    categoryIds: null,
    translationKey: 'table.defensive.team.centers_right_side_received',
    items: [
      {
        category: 'C.P.D.R. ACERTADOS',
        rCategoryIds: [98, 101, 104, 105],
        translationKey: 'table.defensive.team.successful_c_f_r_r',
      },
      {
        category: 'C.P.D.R. NO ACERTADOS',
        rCategoryIds: [106, 107, 108],
        translationKey: 'table.defensive.team.unsuccessful_c_f_r_r',
      },
    ],
  },
  {
    category: 'BALONES RECUPERADOS CANCHA RIVAL',
    categoryIds: null,
    translationKey: 'table.defensive.team.balls_recovered_opponents_half',
    items: [
      {
        category: 'B.R.C.R. EN DISPUTA',
        categoryIds: [487, 488],
        translationKey: 'table.defensive.team.b_r_o_h_in_challenge',
      },
      {
        category: 'B.R.C.R. SIN DISPUTA',
        categoryIds: [491, 492],
        translationKey: 'table.defensive.team.b_r_o_h_without_challenge',
      },
    ],
  },
  {
    category: 'BALONES RECUPERADOS CANCHA PROPIA',
    categoryIds: null,
    translationKey: 'table.defensive.team.balls_recovered_own_half',
    items: [
      {
        category: 'B.R.C.P. EN DISPUTA',
        categoryIds: [485, 486],
        translationKey: 'table.defensive.team.b_r_own_h_in_challenge',
      },
      {
        category: 'B.R.C.P. SIN DISPUTA',
        categoryIds: [489, 490],
        translationKey: 'table.defensive.team.b_r_own_h_without_challenge',
      },
    ],
  },
];

// ToDo: Pending to change a factory to return desired array based on arguments
export function createPossessionTeamRows() {
  return possessionTeamTableRowItems.map(
    ({ category, categoryIds, rCategoryIds, translationKey, items = null, generalName = '' }) => {
      return new TeamTableRow(category, categoryIds, rCategoryIds, translationKey, items, generalName);
    },
  );
}

export function createOffensiveTeamRows() {
  return offensiveTeamTableRowItems.map(
    ({ category, categoryIds, rCategoryIds, translationKey, items = null, generalName = '' }) => {
      return new TeamTableRow(category, categoryIds, rCategoryIds, translationKey, items, generalName);
    },
  );
}

export function createDefensiveTeamRows() {
  return defensiveTeamTableRowItems.map(
    ({ category, categoryIds, rCategoryIds, translationKey, items = null, generalName = '' }) => {
      return new TeamTableRow(category, categoryIds, rCategoryIds, translationKey, items, generalName);
    },
  );
}

export const allCategories = (function() {
  let allCategories = [];
  allCategories = allCategories.concat(getDataTablesCategories(possessionTeamTableRowItems));
  allCategories = allCategories.concat(getDataTablesCategories(offensiveTeamTableRowItems));
  allCategories = allCategories.concat(getDataTablesCategories(defensiveTeamTableRowItems));
  return allCategories;
})();
